/**
 * TK-40 §3 — công tắc **Nguồn NEMA-host** ở trang tủ, chỉ SUPER_ADMIN (lee: "chỉ thấy ở chế độ admin" — ẩn với hạng khác,
 * máy chủ cũng chặn). Ba trạng thái theo lần SLCU XÁC NHẬN gần nhất (`hostBat`): BẬT (lá) · TẮT (xám chữ) · chưa rõ (xám chưa biết).
 * Tắt ⇒ hỏi lại "Mọi đèn của tủ sẽ mất mạng".
 */
import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Modal, useToast } from '../ui';
import { useAuth } from '../../lib/auth';
import { api, errorMessage } from '../../lib/api';
import { qkNema, type LenhNema } from '../../lib/nemaApi';

export function CongTacHost({ cabinetId, hostBat }: { cabinetId: string; hostBat: boolean | null }) {
  const { hasRole } = useAuth();
  const qc = useQueryClient(); const toast = useToast();
  const [hoi, setHoi] = useState(false);
  const gui = useMutation({
    mutationFn: (bat: boolean) => api.post<LenhNema>(`/api/nema/tu/${cabinetId}/nguon-host`, { bat }),
    onSuccess: () => { setHoi(false); void qc.invalidateQueries({ queryKey: qkNema.tu(cabinetId) }); },
    onError: (e) => toast.error('Không gửi được', errorMessage(e)),
  });
  if (!hasRole('SUPER_ADMIN')) return null;
  const nhan = hostBat === null ? 'chưa rõ' : hostBat ? 'BẬT' : 'TẮT';
  const lop = hostBat === null ? 'text-chua-ro' : hostBat ? 'text-tot' : 'text-chu-2';
  return (
    <span className="inline-flex items-center gap-2 rounded-lg border border-vien px-2.5 py-1 text-sm" data-o="cong-tac-host">
      <span className="text-chu-2">Nguồn NEMA-host:</span>
      <span className={`font-semibold ${lop}`} data-host={nhan}>{nhan}</span>
      <Button size="sm" variant="secondary" loading={gui.isPending} onClick={() => (hostBat === false ? gui.mutate(true) : setHoi(true))}>
        {hostBat === false ? 'Bật' : 'Tắt'}
      </Button>
      <Modal open={hoi} onClose={() => setHoi(false)} title="Tắt nguồn NEMA-host"
        footer={<><Button variant="secondary" onClick={() => setHoi(false)}>Quay lại</Button><Button variant="danger" loading={gui.isPending} onClick={() => gui.mutate(false)}>Tắt</Button></>}>
        <p className="m-0 text-sm text-chu-1">Mọi đèn của tủ sẽ mất mạng</p>
      </Modal>
    </span>
  );
}
